export class FlipHeaderInfo {
  lastAssessmentDate: Date
  totalScore: number
  totalCount: number

  constructor(data?: any) {
    this.lastAssessmentDate = data?.lastAssessmentDate ?? null
    this.totalScore = data?.totalScore ?? 0
    this.totalCount = data?.totalCount ?? 0
  }
}
